<template>
	<span class="count-button">
		<span
			class="minus"
			@click="decrease"
			:class="{ disabled: itemsCount === minCount }"
		>
			minus
		</span>
		<span class="count">{{ itemsCount }}</span>
		<span
			class="plus"
			@click="increase"
			:class="{ disabled: itemsCount >= maxCount || isAddButtonDisabled }"
		>
			plus
		</span>
	</span>
</template>

<script>
export default {
	name: 'CountButton',

	props: {
		itemsCount: Number,

		minCount: {
			type: Number,
			default: 1
		},

		maxCount: {
			type: Number,
			default: 999
		},

		isAddButtonDisabled: {
			type: Boolean,
			default: false
		}
	},

	methods: {
		decrease() {
			this.$emit('decrease')
		},

		increase() {
			this.$emit('increase')
		}
	}
}
</script>

<style lang="scss">
@import './src/assets/styles/variables';

.count-button {
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 144px;
	padding: 10px;
	font-size: 16px;
	color: #fff;
	border-radius: 32px;
	border: 2px solid $border-color;

	.minus,
	.plus {
		width: 24px;
		height: 24px;
		padding: 0;
		margin: 0;
		text-indent: -9999px;
		color: #fff;
		position: relative;
		overflow: hidden;
		cursor: pointer;

		&:before,
		&:after {
			position: absolute;
			left: 4px;
			top: 11px;
			width: 16px;
			border-top: 2px solid #fff;
			border-radius: 5px;
			content: '';
		}

		&:after {
			transform: rotate(90deg);
		}

		&.disabled {
			opacity: 0.25;
		}
	}

	.minus:after {
		display: none;
	}
}
</style>
